import React, { forwardRef } from 'react';
import { cn } from '../utils/cn';

const paddings = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
};

export const Card = forwardRef(function Card(
  { children, className, padding = 'md', hover = false, as: Component = 'div', ...props },
  ref
) {
  return (
    <Component
      ref={ref}
      className={cn(
        'rounded-2xl border border-gray-100 bg-white shadow-sm',
        hover && 'transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg',
        paddings[padding],
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
});

Card.displayName = 'Card';

export function CardHeader({ children, className }) {
  return <div className={cn('mb-4', className)}>{children}</div>;
}

export function CardTitle({ children, className, as: Tag = 'h3' }) {
  return <Tag className={cn('text-lg font-semibold text-gray-900', className)}>{children}</Tag>;
}

export function CardDescription({ children, className }) {
  return <p className={cn('text-sm text-gray-600 mt-1', className)}>{children}</p>;
}

export function CardContent({ children, className }) {
  return <div className={cn(className)}>{children}</div>;
}

export function CardFooter({ children, className }) {
  return <div className={cn('mt-6 flex flex-wrap gap-3', className)}>{children}</div>;
}
